import React from 'react';
import { useTranslation } from 'react-i18next';
import { Text, Flex, RectangularButton } from '@resideo/blueprint-react';
import ModalHeader from 'components/common/ModalHeader';

export const DeleteUserModalError = ({ onCancel }) => {
  const { t } = useTranslation();

  return (
    <>
      <ModalHeader
        title={t('deleteUser.errorModalTitle')}
        textAlign='center'
        closeModal={onCancel}
      />
      <Text
        data-test-delete-user-modal-error-text
        textAlign='center'
        marginBottom='small'
        paddingBottom={'medium'}
        justifyContent='center'>
        {t('deleteUser.errorModalText')}
      </Text>
      <Flex flexDirection='column'>
        <RectangularButton
          data-test-delete-user-modal-submit-button
          type='button'
          variant='secondary'
          onClick={onCancel}>
          {t('common.close')}
        </RectangularButton>
      </Flex>
    </>
  );
};
